export default {
  name: 'collectionFilters',
  component(props: { collectionUrl: string; showCta: boolean }) {
    let isLoaded = false
    // @ts-expect-error setup Alpine types correctly?
    const form: HTMLFormElement = this.$el
    let selects: NodeList = form.querySelectorAll('select')
    let mainFilter: HTMLSelectElement | null = form.querySelector('select[data-main-filter]')

    return {
      isLoaded: false,
      form: null,
      selects: null,
      mainFilter: null,

      init() {
        this.updateContentWithSelectedFilters()
      },

      async updateContentWithSelectedFilters(onlyMainFilter = false) {
        if (props.collectionUrl) {
          let formReference: HTMLFormElement | null = form
          // If not loaded and current page is different from the collection page, get the form from the collection page
          if (isLoaded === false && !window.location.pathname.includes(props.collectionUrl)) {
            await fetch(`${props.collectionUrl}?section_id=slice-collection-filters`)
              .then((response) => response.text())
              .then((html) => {
                const parser = new DOMParser()
                const doc = parser.parseFromString(html, 'text/html')
                formReference = doc.querySelector('form')
              })
              .catch((error) => {
                console.error('Error fetching the url:', error)
              })
          }

          // Define the url to fetch with filters
          const url = new URL(props.collectionUrl, window.location.origin)
          url.search = ''
          let formData = new FormData(formReference)
          if (onlyMainFilter) {
            // Create a new FormData with only the main filter
            const mainFilterKey = mainFilter?.getAttribute('name') || ''
            const mainFilterValue = mainFilter?.value || ''
            const newFormData = new FormData()
            newFormData.append(mainFilterKey, mainFilterValue)

            // Replace formData by newFormData
            formData = newFormData
          }
          const params = new URLSearchParams(formData as unknown as Record<string, string>)
          url.search = params.toString()

          if (isLoaded === true && !props.showCta) {
            window.location.href = url.toString()
            return
          }

          // Add search param "section_id=slice-collection-filters" to fetch only the content of the section
          url.searchParams.set('section_id', 'slice-collection-filters')

          // Fetch the url and update the content
          /* eslint-disable promise/catch-or-return */
          fetch(url.toString())
            .then((response) => response.text())
            .then((html) => {
              const parser = new DOMParser()
              const doc = parser.parseFromString(html, 'text/html')
              const destination = form.querySelector('[data-dynamic-content]')
              const source = doc.querySelector('[data-dynamic-content]')
              if (destination && source) {
                destination.innerHTML = source.innerHTML

                // Update selects and main filter
                selects = form.querySelectorAll('select')
                mainFilter = form.querySelector('select[data-main-filter]')
              } else {
                console.error('Error updating content:', { destination, source })
              }
            })
            .catch((error) => {
              console.error('Error fetching the url:', error)
            })
            .finally(() => {
              this.initSelects()
              if (isLoaded === false) {
                form.classList.add('loaded')
                isLoaded = true
              }
            })
        }
      },

      initSelects() {
        if (selects.length > 0) {
          selects.forEach((select) => {
            select.addEventListener('change', (e) => {
              e.preventDefault()
              e.stopPropagation()
              if (select === mainFilter) {
                this.updateContentWithSelectedFilters(true)
              } else {
                this.updateContentWithSelectedFilters(false)
              }
            })
          })
        }
      }
    }
  }
}
